export default __webpack_public_path__ + "static/media/CNo.80-2.e6ca16dc.jpg";